// extracted by mini-css-extract-plugin
export default {"tasks":"HO-z","task":"IO-z","svg":"JO-z","text":"KO-z"};